import { useCallback } from 'react';
import type { ElasticRetailer } from '@//app/api/retailers/[slug]';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackOutboundLinkRetailerEventData } from './legacy-types';

export const createLegacyTrackOutboundLinkRetailer = (
  branch: ElasticRetailer,
): LegacyTrackOutboundLinkRetailerEventData => {
  const eventData: LegacyTrackOutboundLinkRetailerEventData = {
    eventType: 'other',
    conversionType: 'outbountlink-retailer',
    pageType: 'dealer page',
    branch: {
      id: branch.id,
    },
  };

  return eventData;
};

export const useLegacyTrackOutboundLinkRetailer = () => {
  const { track } = useLegacyTracking();

  const trackLegacyOutboundLinkRetailer = useCallback(
    (branch: ElasticRetailer) => {
      track({
        event: 'other',
        data: createLegacyTrackOutboundLinkRetailer(branch),
      });
    },
    [track],
  );

  return {
    trackLegacyOutboundLinkRetailer,
  };
};
